import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-navigation mt-8 pt-6 border-t border-gray-200" }
const _hoisted_2 = { class: "nav-buttons" }
const _hoisted_3 = { class: "prev-button" }

import ActionButton from '@/components/ui/ActionButton.vue';

import type { StepNavigationProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'StepNavigation',
  props: {
    currentStep: {},
    totalSteps: {},
    canProceed: { type: Boolean },
    canSubmit: { type: Boolean },
    isLoading: { type: Boolean, default: false },
    submitLabel: { default: 'Soumettre' }
  },
  emits: ["previous", "next"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentStep < _ctx.totalSteps - 1)
        ? (_openBlock(), _createBlock(ActionButton, {
            key: 0,
            variant: "primary",
            size: "lg",
            disabled: !_ctx.canProceed,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('next'))),
            label: "Suivant",
            icon: "fas fa-arrow-right"
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.currentStep === _ctx.totalSteps - 1)
        ? (_openBlock(), _createBlock(ActionButton, {
            key: 1,
            variant: "success",
            size: "lg",
            type: "submit",
            disabled: !_ctx.canSubmit,
            loading: _ctx.isLoading,
            label: _ctx.submitLabel,
            icon: "fas fa-check"
          }, null, 8, ["disabled", "loading", "label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.currentStep > 0)
        ? (_openBlock(), _createBlock(ActionButton, {
            key: 0,
            variant: "secondary",
            size: "lg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('previous'))),
            label: "Précédent",
            icon: "fas fa-arrow-left"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})